import { z } from 'zod';

export const $CandidateResumeActivity = z.object({
  is_active: z.boolean(),
});
